// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Management
const ManageMidBuyerList = () => import('@/modules/mid_buyers/views/management/ManageMidBuyerList')

var routes = [
    {
        path: '/mid-buyers',
        redirect: '/mid-buyers/manage/list',
        name: 'MidBuyers',
        component: DefaultContainer,
        children: [
            {
				path: '/mid-buyers/manage/list',
                name: 'ManageMidBuyerList',
                component: ManageMidBuyerList,
                meta: {
                    requiresAuth: true,
                    permission: false,
                },
            },
        ]
    },
];

export default routes;
